export default __webpack_public_path__ + "static/sylasInactive-fe8a7bcf68e829975752e7afb79475e4.png";